import { InputAdornment } from '@mui/material';

export const getRenderCurrencyPrefixProps = (prefix: string) => ({
  classes: {
    input: '!pl-0 text-[14px] font-normal !h-[38px]',
  },
  startAdornment: (
    <InputAdornment position="start" className="mr-0.5 mt-[1px]">
      <span className="text-[14px] text-black-heading">{prefix}</span>
    </InputAdornment>
  ),
});
